export const getProductSlug = (product) => product?.slug || String(product?.id || "");

export const getProductPath = (product) => `/product/${getProductSlug(product)}`;

export const resolveProductByIdentifier = (products, identifier) => {
  const value = decodeURIComponent(String(identifier || ""));
  return (
    products.find((product) => product.slug === value) ||
    products.find((product) => String(product.id) === value)
  );
};
